<template>
	<div id="hres80x-history-heal-others" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#historyHealOthers">
      <h3 class="box-title color-skin">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i> {{labels['HRES80XP4']['10']}}
      </h3>
    </div>
    <div id="historyHealOthers" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
        	<!-- header -->
          <div class="hisheal-header">{{labels['HRES80XP4']['20']}}</div>
          <!-- detail -->
          <textarea class="hisheal-others" :value="dataHisHeal.desnote" readonly></textarea>
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres80x-history-heal-others',
  props: [
    'labels',
    'dataHisHeal'
  ]
}
</script>



// WEBPACK FOOTER //
// historyHealOthers.vue?94bdd238